import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Offer} from '../../../../../core/models/offer/offer.model';
import {OfferBasicItemComponent} from '../../../../components/offer-basic-item/offer-basic-item.component';
import {LanguageService} from '../../../../services/language.service';
import {DetailCoverageGroupBox, OfferCoveragesService} from '../../../../../core/services/impl/offer-coverages.service';
import {MatCheckbox} from '@angular/material';
import {Ga4EventsConfigService} from '../../../../../core/services/ga4-events-config.service';
import {Ga4OffersElementKey} from '../../../../../core/consts/ga4-offers-element-key.enum';
import {OfferService} from '../../../../../core/services/impl/offer.service';
import {OfferRecommendationType} from '../../../../../core/consts/offer-recommendation-type.enum';
import {
  OfferRecommendationConfig,
  OfferRecommendationRoleConfig
} from '../../../../../core/models/offer/offer-recommendation-config';
import {OfferRecommendationsService} from '../../../../../core/services/impl/offer-recommendations.service';
import {OfferResourceService} from '../../../../../core/services/impl/offer-resource.service';
import {isCarOne} from '../../../../../core/utils/utils';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {AssetsService} from '../../../../services/assets.service';

@Component({
  selector: 'app-next-offer',
  templateUrl: './next-offer.component.html',
  styleUrls: []
})
export class NextOfferComponent extends OfferBasicItemComponent implements OnInit {

  @Input() offer: Offer;
  @Input() addOfferToComparisonAllowed: boolean;
  @Input() compareCheckboxChecked: boolean;
  @Input() comparisonOffersAmount: number;

  @Output() addToComparison: EventEmitter<void> = new EventEmitter<void>();
  @Output() removeFromComparison: EventEmitter<void> = new EventEmitter<void>();
  @Output() showComparison: EventEmitter<void> = new EventEmitter<void>();
  @Output() showDetails: EventEmitter<void> = new EventEmitter<void>();
  @Output() select: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('compareCheckbox') compareCheckbox: MatCheckbox;

  detailCoverageGroupBoxes: DetailCoverageGroupBox[];
  comparingOffersAllowed: boolean = !isCarOne();
  detailsButtonIcon: string = isCarOne() ? 'arrow_forward' : 'arrow_right';
  buyOnlineButtonLabel: string = isCarOne() ? 'OFFER_SECTION.SHARED.selectAndContinue' : 'OFFER_SECTION.SHARED.buyOnline';
  anyDetailCoverages: boolean;

  get recommendationType(): OfferRecommendationType | null {
    return this.offerRecommendationsService.getOfferRecommendationType(this.offer);
  }

  get recommendationConfig(): OfferRecommendationConfig | null {
    return this.recommendationType ? this.offerRecommendationsService.getConfig(this.recommendationType) : null;
  }

  get recommendationRoleConfig(): OfferRecommendationRoleConfig | null {
    return this.recommendationConfig ? this.offerRecommendationsService.getRoleConfig(this.recommendationType) : null;
  }

  get cssClassSuffix(): string {
    return this.recommendationRoleConfig ? this.recommendationRoleConfig.cssClassSuffix : null;
  }

  get compareIconSrc(): string {
    return this.compareCheckboxChecked ? `${this.assetsService.getIconsDirectoryPath()}/offers-comparison-active.svg` : './assets/images/icons/offers-comparison.svg';
  }

  get compareButtonLabel(): string {
    return this.compareCheckboxChecked ? 'OFFER_ITEM.COMPARISON.compareSelected' : 'OFFER_ITEM.COMPARISON.compare';
  }

  constructor(resourceService: OfferResourceService,
              language: LanguageService,
              public offerRecommendationsService: OfferRecommendationsService,
              private ga4EventsService: Ga4EventsConfigService,
              private offerService: OfferService,
              private assetsService: AssetsService,
              public offerCoveragesService: OfferCoveragesService) {
    super(resourceService, language);
  }

  ngOnInit() {
    this.createBoxes(this.offer);
    this.setAmount(this.offer);
    this.setLogo(this.offer);
  }

  protected createBoxes({coverages}: Offer) {
    super.createBoxes(this.offer);
    this.detailCoverageGroupBoxes = this.offerCoveragesService.createDetailCoverageGroupBoxes(this.offer);
    this.anyDetailCoverages = this.detailCoverageGroupBoxes
        .some(group => isNotNullOrUndefined(group.boxes) && group.boxes.length > 0 && group.boxes.some(box => this.canShowBox(box.options, box.selectedOption, box.enabled)));
  }

  showOfferDetails(): void {
    this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.OFFER_DETAILS);
    this.showDetails.emit();
  }

  selectOffer(): void {
    this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.BUY_ONLINE_LIST);
    this.select.emit();
  }

  changeCompareCheckbox(): void {
    if (this.compareCheckboxChecked) {
      this.removeFromComparison.emit();
    } else {
      this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.COMPARE_OFFERS_ADD);
      this.addToComparison.emit();
    }
  }

  compareOffers(event: PointerEvent) {
    if (this.compareCheckboxChecked) {
      this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.COMPARE_OFFERS_PROCEED);
      this.showComparison.emit();
      event.preventDefault();
    }
  }

}
